import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsynParishPriestList({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/parishPriest"));
  console.log("Loading", AsynParishPriestList.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsynParishPriestList;
